import React, { useEffect, useMemo, useState } from "react";
import Modal from "./Modal";
import { IconButton, Slide, Typography } from "@mui/material";
import { getIcon } from "utils/iconsConfig";
import { useLocation } from "react-router-dom";
import "./imageModal.css";
import watermarkImageUrl from "../../assets/img/watermark.png";
import Image from "assets/img/default-img.jpg";
import { useGlobalContext } from "context/GlobalContext";
import { useDispatch, useSelector } from "react-redux";
import { addEditCategory, addToCart, removeEditCategory, removeFromCart } from "store/cartSlice";

const ImageModal = ({
  open,
  handleClose,
  data,
  hasAccessToSeeWatermark,
  hasNext,
  hasPrev,
  nextClick,
  prevClick,
  selectedCartProducts,
  setQty,
  qty,
  /** When "left", modal anchors to the left viewport edge (e.g. alongside a right-side drawer). */
  anchor = "right",
  rightOffset,
}) => {
  const location = useLocation();
  const splitedPaths = location.pathname.split("/");
  const needMargin = splitedPaths.includes("Set") || (splitedPaths.includes("Sets") && splitedPaths[splitedPaths.length - 1] === "Sets");
  const dispatch = useDispatch();

  // const { isEditCatagoryData, setIsEditCatagoryData } = useGlobalContext();

  const isEditCatagoryData = useSelector((state) => state.editCategory.data);

  const cartData = useSelector((state) => state.cart.cartData);

  const hideForwardAndBackwardBtn = location?.state?.name?.length > 2 && location.pathname.includes("Stock");

  const [zoomStyle, setZoomStyle] = useState({});

  const updateCatagoryData = location?.state?.updateCatagory;

  const isInCart = Array.isArray(cartData) ? cartData.some((item) => item?.styleNumber === data?.designNo) : false;
  const isInUpdateDesigns = useMemo(() => {
    return Array.isArray(isEditCatagoryData) ? isEditCatagoryData.some((item) => item?.styleNumber === data?.designNo) : false;
  }, [isEditCatagoryData, data?.designNo]);

  // const handleAddEditCatagoryData = (selectedCartProducts) => {
  //   let getUpdateCatagoryData = JSON.parse(sessionStorage.getItem(updateCatagoryData)) || [];
  //   getUpdateCatagoryData.push({
  //     _id: selectedCartProducts?._id || selectedCartProducts?.id,
  //     styleNumber: selectedCartProducts?.styleNumber,
  //   });
  //   sessionStorage.setItem(updateCatagoryData, JSON.stringify(getUpdateCatagoryData));
  //   setIsEditCatagoryData(getUpdateCatagoryData || []);
  //   window.dispatchEvent(new Event("UpdateSubCategory"));
  // };

  const handleAddEditCatagoryData = (selectedCartProducts) => {
    dispatch(
      addEditCategory({
        storageKey: updateCatagoryData,
        data: {
          _id: selectedCartProducts?._id || selectedCartProducts?.id,
          styleNumber: selectedCartProducts?.styleNumber,
        },
      })
    );
  };

  // const removeCatagoryForEdit = (productToRemove) => {
  //   let getUpdateCatagoryData = JSON.parse(sessionStorage.getItem(updateCatagoryData)) || [];
  //   getUpdateCatagoryData = getUpdateCatagoryData.filter((item) => (item?.id || item?._id) !== (productToRemove?.id || productToRemove?._id));
  //   sessionStorage.setItem(updateCatagoryData, JSON.stringify(getUpdateCatagoryData));
  //   setIsEditCatagoryData(getUpdateCatagoryData || []);
  //   window.dispatchEvent(new Event("UpdateSubCategory"));
  // };

  const removeCatagoryForEdit = (productToRemove) => {
    dispatch(
      removeEditCategory({
        storageKey: updateCatagoryData,
        id: productToRemove.id || productToRemove._id,
      })
    );
  };

  const toggleCart = () => {
    if (isInCart || isInUpdateDesigns) {
      if (isInCart) {
        dispatch(removeFromCart(selectedCartProducts));
      } else {
        removeCatagoryForEdit(selectedCartProducts);
      }
    } else {
      if (!location?.state?.isEditCatagory) {
        // addToCart({ ...selectedCartProducts, isAddedInCart: true });
        //  dispatch(addToCart(selectedCartProducts));
        dispatch(
          addToCart({
            product: selectedCartProducts,
            location: location,
          })
        );
      } else {
        handleAddEditCatagoryData(selectedCartProducts);
      }
    }
  };

  const handleMouseMove = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    setZoomStyle({
      transform: "scale(2.5)",
      transformOrigin: `${x}% ${y}%`,
    });
  };

  const handleMouseLeave = () => {
    setZoomStyle({ transform: "scale(1)", transformOrigin: "center" });
  };

  const handleDownLoadImageFile = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename || "file");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!open) return;

      if (e.key === "ArrowRight" && hasNext) {
        nextClick();
      } else if (e.key === "ArrowLeft" && hasPrev) {
        prevClick();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, hasNext, hasPrev, nextClick, prevClick]);

  const anchorLeft = anchor === "left";
  const modalPositionStyle = anchorLeft
    ? { width: "40vw", height: "85vh", boxShadow: "none", left: 0, ml: needMargin ? 70 : 2, slideDirection: "right" }
    : { width: "40vw", height: "85vh", mr: rightOffset ?? (needMargin ? 70 : null), boxShadow: "none", slideDirection: "left" };

  return (
    <Modal open={open} handleClose={handleClose} style={modalPositionStyle}>
      <Slide direction={anchorLeft ? "right" : "left"} in={open} timeout={500} mountOnEnter unmountOnExit>
        <div style={{ width: "100%", height: "100%" }}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Typography
                id="modal-drawer-title"
                variant="h5"
                style={{
                  fontFamily: "Poppins",
                  fontWeight: "500",
                  fontSize: "22px",
                }}
              >
                {data?.designNo ? data?.designNo : data?.styleNumber}
                {location?.state?.name?.[0] === "Orders" && `(${data?.category})`}
              </Typography>

              {/* Cart Toggle Icon */}

              {location?.pathname !== "/CartOrder" &&
                (location?.state?.newName === "Create Order" ||
                  location?.state?.newName === "New Catalog" ||
                  location?.state?.newName === "New Collection" ||
                  location?.state?.newName === "Update Design Class" ||
                  location?.state?.newName === "Update Make Type" ||
                  location?.state?.newName === "Restrict Design" ||
                  location?.state?.newName === "Update Sub-category" ||
                  location?.state?.newName === "New Set") && (
                  <IconButton disableFocusRipple disableRipple sx={{ p: 0 }} onClick={toggleCart}>
                    {isInCart || isInUpdateDesigns ? getIcon("selectCartIcon") : getIcon("disselectCartIcon")}
                  </IconButton>
                )}
            </div>

            <div style={{ display: "flex", gap: "12px" }}>
              <div style={{ display: "flex", gap: "12px" }}>
                {location?.state?.name?.[0] === "Orders" && (
                  <>
                    <IconButton disableFocusRipple disableRipple sx={{ p: 0 }} onClick={() => handleDownLoadImageFile(data?.url, data?.styleNumber)}>
                      {getIcon("BigDownloadIcon")}
                    </IconButton>
                  </>
                )}
                {!hideForwardAndBackwardBtn && (
                  <>
                    <IconButton disableFocusRipple disableRipple sx={{ p: 0, cursor: hasPrev ? "pointer" : "not-allowed", opacity: hasPrev ? 1 : 0.5 }} onClick={prevClick}>
                      {getIcon("PrevIcon")}
                    </IconButton>
                    <IconButton disableFocusRipple disableRipple sx={{ p: 0, cursor: hasNext ? "pointer" : "not-allowed", opacity: hasNext ? 1 : 0.5 }} onClick={nextClick}>
                      {getIcon("NextIcon")}
                    </IconButton>
                  </>
                )}
              </div>

              <IconButton disableFocusRipple disableRipple sx={{ p: 0 }} onClick={handleClose}>
                {getIcon("BigBoxCrossIcon")}
              </IconButton>
            </div>
          </div>

          {/* Body */}
          <div style={{ width: "100%", height: "93%", marginTop: "10px" }} className="zoom-container">
            <img
              className="zoom-image"
              src={data?.Orgimg ? data?.Orgimg : data?.imgUrl ? data?.imgUrl : data?.imageUrl ? data?.transformedImageUrl : data?.url ? data?.url : Image}
              alt="Zoomable"
              style={{...zoomStyle, objectFit: "contain"}}
              onMouseMove={handleMouseMove}
              onMouseLeave={handleMouseLeave}
              onContextMenu={(e) => e.preventDefault()}
              onTouchStart={(e) => e.preventDefault()}
              draggable="false"
            />
            {hasAccessToSeeWatermark && open && (data?.imgUrl || data?.imageUrl || data?.url || data?.Orgimg) && (
              <div
                style={{
                  position: "absolute",
                  top: 10,
                  left: 41,
                  width: "85%",
                  height: "94%",
                  backgroundImage: `url(${watermarkImageUrl})`,
                  backgroundRepeat: "repeat",
                  backgroundSize: "400px 400px",
                  opacity: 1,
                  pointerEvents: "none",
                }}
              />
            )}
          </div>
        </div>
      </Slide>
    </Modal>
  );
};

export default ImageModal;
